import Vue from 'vue'
import VueRouter from 'vue-router'

import Main from '@/components/Main.vue';
import Industry from '@/components/Industry.vue';
import LiveCameras from '@/components/Livecams/LiveCameras.vue';
import CoralCityCamera from '@/components/Livecams/CoralCityCamera.vue';
import WahooBay from '@/components/Livecams/WahooBay.vue';
import OkaloosaIslandPier from '@/components/Livecams/OkaloosaIslandPier.vue';
import Angler from '@/components/Products/Angler.vue';
import Comparesystems from '@/components/Products/compare-systems.vue';
import Octopus from '@/components/Products/octopus.vue';
import Periscope from '@/components/Products/periscope.vue';
import About from '@/components/About.vue';
import Resources from '@/components/Resources.vue';
import Contact from '@/components/Contact.vue';
import Terms from '@/components/Terms.vue';
import Warranty from '@/components/Warranty.vue';

Vue.use(VueRouter)

const routes = [
    // {
    //   path: '/',
    //   name: 'Home',
    //   component: Home,
    // },
    {
      path: '/',
      component: Main,
    },
    {
      path: '/industry',
      component: Industry,
    },
    {
       path: '/live-cameras/coral-city',
       component: CoralCityCamera,
    },
    {
        path: '/live-cameras/wahoo-bay',
        component: WahooBay,
    },
    {
        path: '/live-cameras/okaloosa-island-pier',
        component: OkaloosaIslandPier,
    },
    {
         path: '/live-cameras/mega-lab-hawaii-1',
         component: LiveCameras,
    },
    {
        path: '/products/Angler',
        alias: '/products/angler',
        component: Angler,
    },
    {
        path: '/products/octopus',
        component: Octopus,
    },
    {
        path: '/products/periscope',
        component: Periscope,
    },
    {
        path: '/products/comparesystems',
        component: Comparesystems,
    },
    {
      path: '/about',
      component: About,
    },
    {
      path: '/resources',
      component: Resources,
    },
    {
      path: '/contact',
      component: Contact,
    },
    {
      path: '/terms',
      component: Terms,
    },
    {
      path: '/warranty',
      component: Warranty,
    },
    {
      path: "*",
      redirect: '/' 
    },
]

const router = new VueRouter({
  // mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  },
})

export default router
